import { Record } from 'immutable'
import queryString, { type ParsedQuery } from 'query-string'

type QueryRecordType = Partial<{
  campaign_search: string
  campaigns: string
  card: string
  converted: string
  count: string
  countries: string
  country: string
  coupon: string
  csv_count: string
  current_customer_id: string
  date_from: string
  date_to: string
  delay: string
  department: string
  domain_ids: string
  duration_max: string
  duration_min: string
  employees_max: string
  employees_min: string | number
  engaged: string
  ex_domain_ids: string
  ex_locations: string
  ex_industries: string
  ex_interest_ids: string
  ex_origination: string
  ex_tag_ids: string
  ex_utm_campaigns: string
  ex_utm_terms: string
  ex_utm_mediums: string
  ex_utm_sources: string
  ex_tech: string
  from: string
  id: string
  industries: string
  interest_ids: string
  ip_countries: string
  keywords: string
  leadId: string
  companyId: string
  locations: string
  main_category: string
  match: string
  modal: string
  nace: string
  name: string
  order: string
  order_by: string
  origination: string
  page: string | number
  page_size: string
  contacts_page: string | number
  contacts_page_size: string
  period: string
  profile: string
  query: string
  range: string
  revenue_max: string
  revenue_min: string
  role: string
  search: string
  segment_id: string
  source: string
  status: string
  sub_category: string
  subscription: string
  tab: string
  tag_ids: string
  target_list_id: string
  tech: string
  time: string
  type: string
  update: string
  utm_campaigns: string
  utm_terms: string
  utm_mediums: string
  utm_sources: string
  vat_number: string
  visits_max: string
  visits_min: string | number
  wildcard: string
}>

const QueryRecord = Record({
  campaign_search: '',
  campaigns: '',
  card: '',
  converted: '',
  count: '',
  countries: '',
  country: '',
  coupon: '',
  csv_count: '',
  current_customer_id: '',
  date_from: '',
  date_to: '',
  delay: '',
  department: '',
  domain_ids: '',
  duration_max: '',
  duration_min: '',
  employees_max: '',
  employees_min: '',
  engaged: '',
  ex_domain_ids: '',
  ex_locations: '',
  ex_industries: '',
  ex_interest_ids: '',
  ex_origination: '',
  ex_tag_ids: '',
  ex_utm_campaigns: '',
  ex_utm_terms: '',
  ex_utm_mediums: '',
  ex_utm_sources: '',
  ex_tech: '',
  from: '',
  id: '',
  industries: '',
  interest_ids: '',
  ip_countries: '',
  keywords: '',
  leadId: '',
  companyId: '',
  locations: '',
  main_category: '',
  match: '',
  modal: '',
  nace: '',
  name: '',
  order: '',
  order_by: '',
  origination: '',
  page: '',
  page_size: '',
  contacts_page: '',
  contacts_page_size: '',
  period: '',
  profile: '',
  query: '',
  range: '',
  revenue_max: '',
  revenue_min: '',
  role: '',
  search: '',
  segment_id: '',
  source: '',
  status: '',
  sub_category: '',
  subscription: '',
  tab: '',
  tag_ids: '',
  target_list_id: '',
  tech: '',
  time: '',
  type: '',
  update: '',
  utm_campaigns: '',
  utm_terms: '',
  utm_mediums: '',
  utm_sources: '',
  vat_number: '',
  visits_max: '',
  visits_min: '',
  wildcard: '',
})

export const createSearch = (oldQuery: ParsedQuery, newQuery: ParsedQuery) => {
  const query: QueryRecordType = QueryRecord({ ...oldQuery, ...newQuery }).toObject()

  if (!query.campaign_search) delete query.campaign_search
  if (!query.campaigns) delete query.campaigns
  if (!query.card) delete query.card
  if (!query.converted) delete query.converted
  if (!query.count?.length) delete query.count
  if (!query.countries?.length) delete query.countries
  if (!query.country?.length) delete query.country
  if (!query.coupon?.length) delete query.coupon
  if (!query.csv_count) delete query.csv_count
  if (!query.current_customer_id) delete query.current_customer_id // shall we remove it?
  if (!query.date_from) delete query.date_from
  if (!query.date_to) delete query.date_to
  if (!query.delay) delete query.delay
  if (!query.domain_ids) delete query.domain_ids
  if (!query.department) delete query.department
  if (!query.duration_max) delete query.duration_max
  if (!query.duration_min) delete query.duration_min
  if (!query.employees_max) delete query.employees_max
  if (!query.employees_min || query.employees_min === 1) delete query.employees_min
  if (!query.engaged) delete query.engaged
  if (!query.ex_domain_ids) delete query.ex_domain_ids
  if (!query.ex_locations) delete query.ex_locations
  if (!query.ex_industries) delete query.ex_industries
  if (!query.ex_interest_ids) delete query.ex_interest_ids
  if (!query.ex_origination) delete query.ex_origination
  if (!query.ex_tag_ids) delete query.ex_tag_ids
  if (!query.ex_utm_campaigns) delete query.ex_utm_campaigns
  if (!query.ex_utm_terms) delete query.ex_utm_terms
  if (!query.ex_utm_mediums) delete query.ex_utm_mediums
  if (!query.ex_utm_sources) delete query.ex_utm_sources
  if (!query.ex_tech) delete query.ex_tech
  if (!query.from) delete query.from
  if (!query.id) delete query.id
  if (!query.industries) delete query.industries
  if (!query.interest_ids) delete query.interest_ids
  if (!query.ip_countries?.length) delete query.ip_countries
  if (!query.keywords?.length) delete query.keywords
  if (!query.leadId) delete query.leadId
  if (!query.companyId) delete query.companyId
  if (!query.locations?.length) delete query.locations
  if (!query.main_category) delete query.main_category
  if (!query.match) delete query.match
  if (!query.modal) delete query.modal
  if (!query.nace) delete query.nace
  if (!query.name) delete query.name
  if (!query.order) delete query.order
  if (!query.order_by) delete query.order_by
  if (!query.origination) delete query.origination
  if (!query.page || query.page === 1) delete query.page
  if (!query.page_size) delete query.page_size
  if (!query.contacts_page || query.contacts_page === 1) delete query.contacts_page
  if (!query.contacts_page_size) delete query.contacts_page_size
  if (!query.period) delete query.period
  if (!query.profile) delete query.profile
  if (!query.query) delete query.query
  if (!query.range) delete query.range
  if (!query.role) delete query.role
  if (!query.revenue_max) delete query.revenue_max
  if (!query.revenue_min) delete query.revenue_min
  if (!query.search) delete query.search
  if (!query.segment_id) delete query.segment_id
  if (!query.source) delete query.source
  if (!query.status) delete query.status
  if (!query.sub_category) delete query.sub_category
  if (!query.subscription) delete query.subscription
  if (!query.tab) delete query.tab
  if (!query.tag_ids) delete query.tag_ids
  if (!query.target_list_id) delete query.target_list_id
  if (!query.tech) delete query.tech
  if (!query.time) delete query.time
  if (!query.type) delete query.type
  if (!query.update) delete query.update
  if (!query.utm_campaigns?.length) delete query.utm_campaigns
  if (!query.utm_terms?.length) delete query.utm_terms
  if (!query.utm_mediums?.length) delete query.utm_mediums
  if (!query.utm_sources?.length) delete query.utm_sources
  if (!query.vat_number) delete query.vat_number
  if (!query.visits_max) delete query.visits_max
  if (!query.visits_min || query.visits_min === 1) delete query.visits_min
  if (!query.wildcard) delete query.wildcard

  return queryString.stringify(query)
}

export const buildQueryString = (routerQuery: QueryRecordType = {}) =>
  queryString.stringify(
    {
      campaign_search: routerQuery.campaign_search,
      converted: routerQuery.converted,
      count: routerQuery.count,
      countries: routerQuery.countries,
      country: routerQuery.country,
      current_customer_id: routerQuery.current_customer_id,
      date_from: routerQuery.date_from,
      date_to: routerQuery.date_to,
      delay: routerQuery.delay,
      department: routerQuery.department,
      domain_ids: routerQuery.domain_ids,
      duration_max: routerQuery.duration_max,
      duration_min: routerQuery.duration_min,
      employees_max: routerQuery.employees_max,
      employees_min: routerQuery.employees_min,
      engaged: routerQuery.engaged,
      ex_domain_ids: routerQuery.ex_domain_ids,
      ex_locations: routerQuery.ex_locations,
      ex_industries: routerQuery.ex_industries,
      ex_interest_ids: routerQuery.ex_interest_ids,
      ex_origination: routerQuery.ex_origination,
      ex_tag_ids: routerQuery.ex_tag_ids,
      ex_utm_campaigns: routerQuery.ex_utm_campaigns,
      ex_utm_terms: routerQuery.ex_utm_terms,
      ex_utm_mediums: routerQuery.ex_utm_mediums,
      ex_utm_sources: routerQuery.ex_utm_sources,
      ex_tech: routerQuery.ex_tech,
      filter: routerQuery.tab,
      from: routerQuery.from,
      industries: routerQuery.industries,
      interest_ids: routerQuery.interest_ids,
      ip_country: routerQuery.ip_countries,
      keywords: routerQuery.keywords,
      locations: routerQuery.locations,
      main_category: routerQuery.main_category,
      match: routerQuery.match,
      nace: routerQuery.nace,
      name: routerQuery.name,
      order: routerQuery.order,
      order_by: routerQuery.order_by,
      origination: routerQuery.origination,
      page: routerQuery.page,
      page_size: routerQuery.page_size,
      contacts_page: routerQuery.contacts_page,
      contacts_page_size: routerQuery.contacts_page_size,
      query: routerQuery.query,
      range: routerQuery.range,
      revenue_max: routerQuery.revenue_max,
      revenue_min: routerQuery.revenue_min,
      role: routerQuery.role,
      search: routerQuery.search,
      status: routerQuery.status,
      sub_category: routerQuery.sub_category,
      tag_ids: routerQuery.tag_ids,
      target_list_id: routerQuery.target_list_id,
      tech: routerQuery.tech,
      time: routerQuery.time,
      utm_campaigns: routerQuery.utm_campaigns,
      utm_terms: routerQuery.utm_terms,
      utm_mediums: routerQuery.utm_mediums,
      utm_sources: routerQuery.utm_sources,
      visits_max: routerQuery.visits_max,
      visits_min: routerQuery.visits_min,
      wildcard: routerQuery.wildcard,
    },
    { encode: true },
  )

export const getOffsetFromPage = (page: number, rowsPerPage = 25) => (page - 1) * rowsPerPage
